// extracted by mini-css-extract-plugin
export default {"container":"LabeledForm_container__o5G0b","label":"LabeledForm_label__8wqPV","input":"LabeledForm_input__LNmp5","warning":"LabeledForm_warning__fOyBH"};